import {
  ClearFiltersButton,
  SearchInput,
} from '@/components/data-table/filters';
import type { Accessory } from '@octave/contracts';
import { cn } from '@/lib/utils';

export interface AccessoryFilters {
  category?: string;
  searchQuery: string;
}

interface AccessoryFiltersProps {
  accessories: Accessory[];
  filters: AccessoryFilters;
  onFiltersChange: (filters: AccessoryFilters) => void;
}

export function AccessoryFilters({
  accessories,
  filters,
  onFiltersChange,
}: AccessoryFiltersProps) {
  const uniqueCategories = Array.from(
    new Set(accessories.map((accessory) => accessory.category))
  ).sort();

  const handleChange = <K extends keyof AccessoryFilters>(
    field: K,
    value: AccessoryFilters[K]
  ) => {
    onFiltersChange({ ...filters, [field]: value });
  };

  const hasActiveFilters =
    (filters.category && filters.category !== '') ||
    (filters.searchQuery && filters.searchQuery !== '');

  const handleClear = () => {
    onFiltersChange({ category: '', searchQuery: '' });
  };

  return (
    <div className="flex items-center gap-3 flex-wrap">
      <SearchInput
        placeholder="Rechercher un accessoire..."
        value={filters.searchQuery}
        onChange={(value) => handleChange('searchQuery', value)}
      />

      {/* Category pills */}
      <div className="flex items-center gap-2 flex-wrap bg-white rounded-2xl shadow-sm px-3 py-2">
        <button
          onClick={() => handleChange('category', '')}
          className={cn(
            'rounded-full px-3.5 py-1.5 text-xs font-medium border transition-colors',
            !filters.category
              ? 'bg-emerald-50 text-emerald-700 border-emerald-200'
              : 'bg-slate-50 text-slate-600 border-transparent hover:bg-slate-100'
          )}
        >
          Tous
        </button>
        {uniqueCategories.map((category) => (
          <button
            key={category}
            onClick={() => handleChange('category', category)}
            className={cn(
              'rounded-full px-3.5 py-1.5 text-xs font-medium border transition-colors',
              filters.category === category
                ? 'bg-emerald-50 text-emerald-700 border-emerald-200'
                : 'bg-slate-50 text-slate-600 border-transparent hover:bg-slate-100'
            )}
          >
            {category}
          </button>
        ))}
      </div>

      {hasActiveFilters && <ClearFiltersButton onClick={handleClear} />}
    </div>
  );
}
